export default "__VITE_ASSET__Deboxyb$__"